import { useState, useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { X } from 'lucide-react';
import { useInstallContext, trackInstall } from '@/lib/installContext';
import { InstallInstructions } from '@/components/install/InstallInstructions';

const DISMISS_KEY = 'pwa_prompt_dismissed';
const DISMISS_HOURS = 72;

export default function PWAInstallPrompt() {
  const ctx = useInstallContext();
  const location = useLocation();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (ctx.standalone) return;
    const last = localStorage.getItem(DISMISS_KEY);
    if (last && (Date.now() - parseInt(last)) / 36e5 < DISMISS_HOURS) return;
    if (!ctx.isMobile) return;
    const t = setTimeout(() => { setShow(true); trackInstall('banner_shown'); }, 2500);
    return () => clearTimeout(t);
  }, [ctx.standalone, ctx.isMobile]);

  if (!show || location.pathname.startsWith('/installer')) return null;

  const dismiss = () => { setShow(false); localStorage.setItem(DISMISS_KEY, String(Date.now())); trackInstall('banner_dismissed', ctx); };

  return (
    <div className="fixed bottom-20 md:bottom-4 left-4 right-4 z-[60] max-w-md mx-auto animate-in slide-in-from-bottom-4 duration-300" data-testid="pwa-install-prompt">
      <div className="relative bg-[#18181B] border border-[#FFD700]/30 rounded-2xl p-4 shadow-2xl shadow-black/50">
        <button onClick={dismiss} className="absolute top-3 right-3 text-[#52525B] hover:text-white" aria-label="Fermer" data-testid="pwa-install-dismiss">
          <X className="w-4 h-4" />
        </button>
        <div className="flex items-start gap-3">
          <div className="w-11 h-11 rounded-xl bg-[#FFD700]/10 flex items-center justify-center flex-shrink-0">
            <img src="/icons/icon-192.png" alt="MboaSend" className="w-8 h-8 rounded-lg" />
          </div>
          <div className="flex-1 min-w-0 pr-4">
            <p className="text-sm font-semibold text-white" data-testid="pwa-install-title">Installer MboaSend</p>
            <div className="mt-1">
              <InstallInstructions ctx={ctx} compact onInstalled={() => setShow(false)} />
            </div>
            <Link to="/installer" onClick={() => setShow(false)} className="inline-block mt-2 text-[11px] text-[#FFD700]/80 hover:text-[#FFD700] underline underline-offset-2" data-testid="pwa-install-help-link">
              Besoin d’aide ? Guide d’installation
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
